import React from "react"

import { ChildSelector } from "../../helpers/ChildSelector"

import * as conferenceVideoSectionLeftStyles from "../../styles/conferences/ConferenceVideoSectionLeft.module.css"

export default function VideoSectionLeft(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `conference-title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const text = ChildSelector.select(
    content,
    `conference-text`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const youtubeVideos = ChildSelector.select(
    content,
    `youtube-video`,
    ChildSelector.SELECTOR_TYPE.ARRAY,
  )

  return (
    <div
      className={`row ${props.className} ${conferenceVideoSectionLeftStyles.wrapper}`}
    >
      <div
        className={`col-12 col-lg-6 ${conferenceVideoSectionLeftStyles.contentVideo}`}
      >
        {youtubeVideos && Array.isArray(youtubeVideos) && (
          <div
            className={`row ${conferenceVideoSectionLeftStyles.videoWrapper}`}
          >
            {youtubeVideos.map((v, i) => (
              <>
                <div
                  key={i}
                  className={`col ${conferenceVideoSectionLeftStyles.video}`}
                  dangerouslySetInnerHTML={{ __html: v }}
                />
              </>
            ))}
          </div>
        )}
      </div>
      <div
        className={`col-12 col-lg-6 ${conferenceVideoSectionLeftStyles.content}`}
      >
        <h2>{title}</h2>
        <p>{text}</p>
      </div>
    </div>
  )
}
